import { SITE_NAME } from "../constants/Site";
import { createAxiosInstance } from "./axiosBase";
// Localhost api endpoint
// Auth base url
// const AUTH_BASE_URL = `http://localhost:8001`;

// // Main base url (POS)
// const MAIN_BASE_URL = `http://localhost:8005`;

// //Catalog base url
// const CATALOG_BASE_URL = `http://localhost:8003`;
// // Store base url
// const STORE_BASE_URL = `http://localhost:8002`;


//prod api endpoints:
// Auth base url
const AUTH_BASE_URL = `https://api.totalpe.io/identity`;

// Main base url (POS)
const MAIN_BASE_URL = `https://api.totalpe.io/pos`;

//Catalog base url
const CATALOG_BASE_URL = `https://api.totalpe.io/catalog`;

// Store base url
const STORE_BASE_URL = `https://api.totalpe.io/store`;

export const authApi = createAxiosInstance(AUTH_BASE_URL);
export const mainApi = createAxiosInstance(MAIN_BASE_URL);
export const catalogApi = createAxiosInstance(CATALOG_BASE_URL);
export const storeApi = createAxiosInstance(STORE_BASE_URL);
